import { initialListPaginationMeta } from "utils/helpers/pagination";

import { BodyTypeForm, BodyTypeState } from "../types";

export const initialForm: BodyTypeForm = {
  number: "",
  bodyTypeName: "",
};

export const initialBodyTypeMeta = initialListPaginationMeta;

export const initialState: BodyTypeState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialBodyTypeMeta,
  error: null,
  isAddModalOpen: false,
  form: initialForm,
};
